var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPokeball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0279 7.52943C14.7858 3.85035 11.7249 0.941193 7.98456 0.941193C4.24421 0.941193 1.18333 3.85035 0.941177 7.52943H5.04111C5.26674 6.10701 6.49866 5.01964 7.98456 5.01964C9.47045 5.01964 10.7024 6.10701 10.928 7.52943H15.0279Z",
    fill: "#D00000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.941175 8.47057C1.18333 12.1496 4.24421 15.0588 7.98456 15.0588C11.7249 15.0588 14.7858 12.1496 15.0279 8.47057L10.928 8.47057C10.7024 9.89299 9.47046 10.9804 7.98457 10.9804C6.49867 10.9804 5.26675 9.89299 5.04112 8.47057L0.941175 8.47057Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94534 8C5.94534 6.87377 6.85833 5.96078 7.98456 5.96078C9.11079 5.96078 10.0238 6.87377 10.0238 8C10.0238 9.12623 9.11079 10.0392 7.98456 10.0392C6.85833 10.0392 5.94534 9.12623 5.94534 8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokeball);
export default __webpack_public_path__ + "static/media/pokeball.e64b29d2202400cf6f2b4d07d834becf.svg";
export { ForwardRef as ReactComponent };